import { render, staticRenderFns } from "./digitalTwin.vue?vue&type=template&id=5419271a"
import script from "./digitalTwin.vue?vue&type=script&lang=js"
export * from "./digitalTwin.vue?vue&type=script&lang=js"
import style0 from "./digitalTwin.vue?vue&type=style&index=0&id=5419271a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports